/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ArrowBendDoubleUpLeftOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M7.5 14.25 3 9.75l4.5-4.5m4.5 9-4.5-4.5m0 0 4.5-4.5m-4.5 4.5H12a9 9 0 0 1 9 9"
})));
// Fill
const ArrowBendDoubleUpLeftFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M8.036 13.715a.758.758 0 0 1 0 1.068.767.767 0 0 1-1.068 0l-4.5-4.5a.758.758 0 0 1 0-1.068l4.5-4.5a.757.757 0 0 1 1.018.05.754.754 0 0 1 .05 1.018L4.061 9.749l3.975 3.966zm4.716-4.688V5.249a.749.749 0 0 0-.459-.694.792.792 0 0 0-.825.16l-4.5 4.5a.758.758 0 0 0 0 1.068l4.5 4.5a.777.777 0 0 0 .825.16.749.749 0 0 0 .459-.694v-3.712a8.262 8.262 0 0 1 7.5 8.212c0 .199.079.39.22.53a.747.747 0 0 0 1.06 0 .747.747 0 0 0 .22-.53 9.758 9.758 0 0 0-9-9.722z"
})));
// DuoTone
const ArrowBendDoubleUpLeftDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M7.5 14.25 3 9.75l4.5-4.5m4.5 9-4.5-4.5m0 0 4.5-4.5m-4.5 4.5H12a9 9 0 0 1 9 9"
})));
/**
  Icon ArrowBendDoubleUpLeftIcon in arrows group
*/
export const ArrowBendDoubleUpLeftIcon = createIcon('ArrowBendDoubleUpLeftIcon', 'arrow-bend-double-up-left', 'arrows', ArrowBendDoubleUpLeftOutline, ArrowBendDoubleUpLeftFill, ArrowBendDoubleUpLeftDuotone, "0 0 24 24");